import React from 'react';
import LogService from '../Services/LogService';
import ErrorMessage from './ErrorMessage';
import Loading from './loading.js';
import '../Css/LogComponent.css';

class LogComponent extends React.Component {
  static defaultProps = {
    entityType: 'FreelancerFee',
    entityId: 99,
  };

  constructor(props) {
    super(props);
    this.state = {
      logList: [],
      loading: true,
      selectedLogId: -1,
    };
  }

  componentDidMount() {
    this.populateCommentListData();
  }

  async populateCommentListData() {
    this.setState({ loading: true });
    LogService.GetLogByEntityTypeIdAndEntityId(this.props.entityType, this.props.entityId)
      .then((result) => {
        this.setState({
          logList: result,
          loading: false,
        });
      })
      .catch(() => ErrorMessage.SetErrorMessage('LC43'));
  }

  renderLogList() {
    return (
      <div className='log-card'>
        <div className='log-card-head'>{'Log'}</div>
        <div className='log-list'>
          {this.state.logList.length === 0 && <div className='log-empty'>{'No log entries yet'}</div>}
          {this.state.logList.map((c, index) => {
            const isOpen = this.state.selectedLogId === c.logId;
            return (
              <div
                className='log-item'
                key={'com' + index}
              >
                <button
                  type='button'
                  className={`log-row${isOpen ? ' is-open' : ''}`}
                  onClick={() => this.setState({ selectedLogId: isOpen ? -1 : c.logId })}
                >
                  <i className='log-caret fa-solid fa-chevron-right' />
                  <p className='log-meta'>
                    <span className='log-time'>{c.createdOn}</span>
                    {c.userPersonName ? (
                      <>
                        {' '}
                        · <span className='log-user'>{c.userPersonName}</span>
                      </>
                    ) : null}
                    {c.itemDescription ? (
                      <>
                        {' '}
                        — <span className='log-desc'>{c.itemDescription}</span>
                      </>
                    ) : null}
                  </p>
                </button>
                {isOpen && (
                  <div className='log-detail'>
                    <span className='log-detail-label'>{'New values'}</span>
                    {c.newValues}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className='log-panel verticalScroll panel-max-height'>
        <Loading loading={this.state.loading} />
        {!this.state.loading && this.renderLogList()}
      </div>
    );
  }
}

export default LogComponent;
